var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "best_buys_config_pane" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticStyle: { width: "70%" },
          attrs: { model: _vm.form, "label-width": "100px" },
        },
        [
          _c(
            "el-form-item",
            [
              _c("el-alert", {
                attrs: {
                  title: "* 如果推荐商品在门店下被沽清，则推荐列表不显示",
                  size: "mini",
                  type: "error",
                  effect: "dark",
                  closable: false,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "活动名称：", prop: "activityName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入活动名称" },
                model: {
                  value: _vm.form.activityName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "activityName", $$v)
                  },
                  expression: "form.activityName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "活动价格：", prop: "activityPrice" } },
            [
              _c("el-input-number", {
                attrs: { placeholder: "请输入活动价格", precision: 2, min: 0 },
                on: { change: _vm.handleActivityPriceChange },
                model: {
                  value: _vm.form.activityPrice,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "activityPrice", $$v)
                  },
                  expression: "form.activityPrice",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "text" },
                  on: { click: _vm.applyPriceToAllGoods },
                },
                [_vm._v("\n        应用到所有商品\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "资格限制", prop: "vipMember" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.form.vipMember,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "vipMember", $$v)
                    },
                    expression: "form.vipMember",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: false } }, [
                    _vm._v("\n          游客\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: true } }, [
                    _vm._v("\n          会员\n        "),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.vipMember
                ? _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.memberLevels,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "memberLevels", $$v)
                        },
                        expression: "form.memberLevels",
                      },
                    },
                    _vm._l(_vm.memberLevelList, function (item) {
                      return _c(
                        "el-checkbox",
                        { key: item.gradeId, attrs: { label: item.gradeId } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.gradeName) +
                              "\n        "
                          ),
                        ]
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "点餐类型：", prop: "menuType" } },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.form.menuTypes,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "menuTypes", $$v)
                    },
                    expression: "form.menuTypes",
                  },
                },
                _vm._l(_vm.menuTypeList, function (item) {
                  return _c(
                    "el-checkbox",
                    { key: item.code, attrs: { label: item.code } },
                    [_vm._v("\n          " + _vm._s(item.desc) + "\n        ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "执行周期：" } }, [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("el-date-picker", {
                  attrs: {
                    type: "daterange",
                    format: "yyyy-MM-dd",
                    "value-format": "yyyy-MM-dd",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                  },
                  model: {
                    value: _vm.form.executeDateList,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "executeDateList", $$v)
                    },
                    expression: "form.executeDateList",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "执行时间", prop: "executeTimeList" } },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("el-time-picker", {
                    attrs: {
                      "is-range": "",
                      format: "HH:mm",
                      "value-format": "HH:mm",
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      placeholder: "选择时间范围",
                    },
                    model: {
                      value: _vm.form.executeTimeList,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "executeTimeList", $$v)
                      },
                      expression: "form.executeTimeList",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "推荐商品：", prop: "checkedSuggestGoodsList" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "70%" },
                  attrs: {
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    placeholder: "请搜索选项推荐商品",
                    "remote-method": _vm.searchSuggestGoods,
                    loading: _vm.searchSuggestGoodsLoading,
                    "value-key": "fnId",
                  },
                  model: {
                    value: _vm.suggestGoods,
                    callback: function ($$v) {
                      _vm.suggestGoods = $$v
                    },
                    expression: "suggestGoods",
                  },
                },
                _vm._l(_vm.suggestGoodsList, function (item) {
                  return _c(
                    "el-option",
                    {
                      key: item.fnId,
                      attrs: { label: item.goodsName, value: item },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(item.goodsName) +
                                "(" +
                                _vm._s(item.unitName) +
                                ")"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.goodsCode))]),
                        ]
                      ),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "text" }, on: { click: _vm.addSuggestGoods } },
                [_vm._v("\n        添加\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  key: _vm.goodsTableKey,
                  staticStyle: { width: "70%" },
                  attrs: { border: "", data: _vm.form.checkedSuggestGoodsList },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "goodsCode", label: "商品编号" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "goodsName", label: "商品名称" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "unitName", label: "商品规格" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "活动价格(￥)", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input-number", {
                              attrs: {
                                precision: 2,
                                min: 0,
                                step: 1,
                                size: "small",
                                "controls-position": "right",
                              },
                              model: {
                                value: scope.row.goodsPrice,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "goodsPrice", $$v)
                                },
                                expression: "scope.row.goodsPrice",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "排序", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input-number", {
                              attrs: {
                                min: 0,
                                precision: 0,
                                step: 1,
                                size: "small",
                                "controls-position": "right",
                              },
                              model: {
                                value: scope.row.sorts,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "sorts", $$v)
                                },
                                expression: "scope.row.sorts",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeSuggestGoods(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              移除\n            ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否启用：", prop: "markForEnable" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.form.markForEnable,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "markForEnable", $$v)
                    },
                    expression: "form.markForEnable",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: false } }, [
                    _vm._v("\n          无效\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: true } }, [
                    _vm._v("\n          有效\n        "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "全部门店：", prop: "storeScope" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { "true-label": 0, "false-label": 1 },
                  model: {
                    value: _vm.form.storeScope,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "storeScope", $$v)
                    },
                    expression: "form.storeScope",
                  },
                },
                [_vm._v("\n        全部门店\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.storeScope === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "指定门店", prop: "relatedStoreIdList" } },
                _vm._l(_vm.regionStoreList, function (regionStore) {
                  return _c("region-store-pane", {
                    key: regionStore.regionId,
                    attrs: {
                      "region-store": regionStore,
                      "echo-store-ids": _vm.form.relatedStoreIdList,
                    },
                    on: {
                      change: function (val) {
                        return _vm.handleRegionStoreChange(val, regionStore)
                      },
                    },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("\n        提交\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }